import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { CustomersContext } from "../../../../Context";
import NewStudent from "./NewStudent";
import NewCustomer from "./NewCustomer";
import "./addNewStudent.css";
  
  export default function AddNewStudent(props) {
    const { phoneIn } = useParams()
    const [ phone] = React.useState(phoneIn)
    const { findCustomerByPhone } = useContext(CustomersContext);
    const customer = findCustomerByPhone(phone);

    if (customer) return <NewStudent customer={customer} />

    return (<NewCustomer phone={phone} />)
  };